import React from "react"
import types from "prop-types"
import SvgSpriteIcon from "shared/SvgSpriteIcon"

const DrawerToggleIcon = ({
  ariaHidden = false, className = "", isOpen = false, width = undefined, height = undefined,
}) => {
  if (isOpen) {
    return (
      <SvgSpriteIcon
        className={className}
        iconName="drawer-close"
        width={width}
        height={height}
        ariaHidden={ariaHidden}
      />
    )
  }

  return (
    <SvgSpriteIcon
      className={className}
      iconName="drawer-open"
      width={width}
      height={height}
      ariaHidden={ariaHidden}
    />
  )
}

DrawerToggleIcon.propTypes = {
  ariaHidden: types.bool,
  isOpen: types.bool,
  className: types.string,
  width: types.number,
  height: types.number,
}

export default DrawerToggleIcon
